module.exports = __webpack_public_path__ + "img/logo.394be454.png";